import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const notificationsPersonalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings-notifications',
	path: '/jira/settings/personal/notifications',
};
